import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { routePaths } from '../../urls'
import { checkBrightspaceConfiguration } from '../../actions'
import MissingAKPMessage from './MissingAKPMessage'
import BrightspaceSetup from './Setup'
import Assessments from './Assessments'
import BrightspaceTest from './Test'

class Brightspace extends React.Component {
  componentDidMount() {
    this.unsubscribe = this.context.store.subscribe(() => {
      this.forceUpdate()
    })
    let { coursenum, brightspaceAKPConfigured } = this.context.store.getState()
    if (brightspaceAKPConfigured === undefined) {
      this.context.store.dispatch(checkBrightspaceConfiguration(coursenum))
    }
  }

  componentWillUnmount() {
    this.unsubscribe()
  }

  render() {
    let { brightspaceAKPConfigured } = this.context.store.getState()
    if (!brightspaceAKPConfigured) {
      return <MissingAKPMessage />
    }

    return (
      <div>
        <Route
          path={routePaths.brightspaceSetup}
          component={BrightspaceSetup}
        />
        <Route
          path={routePaths.brightspaceAssessments}
          component={Assessments}
        />
        <Route path={routePaths.brightspaceTest} component={BrightspaceTest} />
        <Route
          exact
          path={routePaths.brightspace}
          render={() => <Redirect to={routePaths.brightspaceSetup} />}
        />
      </div>
    )
  }
}

Brightspace.propTypes = {
  match: PropTypes.object,
}

Brightspace.contextTypes = {
  store: PropTypes.object,
}

export default Brightspace
